const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const Copy = require("./data/CopyTable").getMailListPageCopy();
const AssetsUtil = require("../core/util/AssetsUtil");
const styles = require("./styles/PageMailingList.css");

module.exports = createReactClass({
	displayName: "PageMailingList",

	propTypes: {
		type: PT.oneOf(["confirm", "unsubscribe"]).isRequired,
		// Not currently used to differentiate between unsubscribe types,
		// but included for the future
		subType: PT.string,
		error: PT.string,
	},

	render: function() {
		const {type, error, subType} = this.props;
		const copy = type === "unsubscribe" ? Copy[type][subType] : Copy[type];
		let message = copy["basic"];
		let imgSrc =
			global.BASE_URL + "assets/images/office/characters/happy-fiona-grok.svg";
		let belowContent = (
			<div className={styles.links}>
				<Link to={URLMake.forBookCollections()} className={styles.button}>
					Browse
					<br />
					Books
				</Link>
				<Link to={URLMake.forEnroll()} className={styles.button}>
					Browse
					<br />
					BA Online
				</Link>
			</div>
		);
		if (error) {
			const errorTypeString = this.props.error.substr(6);
			message =
				errorTypeString && copy[errorTypeString]
					? copy[errorTypeString]
					: copy["error"];
			imgSrc = AssetsUtil.getGotProblems();
			belowContent = (
				<Link to={URLMake.forContact()} className={styles.button}>
					Contact Us
				</Link>
			);
		}
		return (
			<div className={styles.main}>
				<img className={styles.image} src={imgSrc} />
				<div className={styles.message}>{message}</div>
				{belowContent}
			</div>
		);
	},
});
